import * as React from "react";
import { connect } from "react-redux";
import Header from "./header";
import Sidebar from "./sidebar";
import Spinner from "../../components/spinner";
import Container from "../../components/container";
import { IStore } from "../../resources/types";

import styles from "./layout.module.css";

interface IProps {
  children: React.ReactChild | React.ReactChild[];
  layoutClass?: string;
  headerClass?: string;
  containerClass?: string;
  loading?: boolean;
  pageTitle?: string;
  goBack?: string;
  useOwnHeader?: boolean;
}

function Layout({
  children,
  loading,
  layoutClass,
  headerClass,
  containerClass,
  pageTitle,
  goBack,
  useOwnHeader
}: IProps) {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  React.useEffect(() => {
    if (layoutClass) {
      document.body.classList.add(layoutClass);
    } else {
      document.body.classList.add(styles.bodyClass);
    }

    return () => {
      if (layoutClass) {
        document.body.classList.remove(layoutClass);
      }
      document.body.classList.remove(styles.bodyClass);
    };
  }, [layoutClass]);

  return (
    <div id="layout">
      {!useOwnHeader && (
        <Header
          goBack={goBack}
          pageTitle={pageTitle}
          className={headerClass}
          isMenuOpen={isMenuOpen}
          setIsMenuOpen={setIsMenuOpen}
        />
      )}
      <Sidebar isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
      <Container className={containerClass}>{children}</Container>
      {loading && <Spinner />}
    </div>
  );
}

export default connect((state: IStore) => ({
  loading: state.loading
}))(Layout);
